import Header from '@components/header';
import FisInfo from '@components/fisInfo';
import StakedValue from '@components/stakedValue';
import CardLine from '@components/cardLine';
import MarketCap from '@components/marketCap';
import RTokenRate from '@components/rTokenRate';
import UniqueUsers from '@components/uniqueUsers';
import StaFiAppchainValidators from '@components/staFiAppchainValidators';
import RedeemValue from '@components/redeemValue';
import StakedTransactions from '@components/stakedTransactions';
import ProtocolIncome from '@components/protocolIncome';
import DailyIncome from '@components/dailyIncome'
export default function Index() {
    return <>
        <Header />
        <FisInfo />
        <StakedValue />
        <CardLine>
            <MarketCap />
            <RTokenRate />
        </CardLine>
        <CardLine>
            <UniqueUsers />
            <StaFiAppchainValidators />
        </CardLine>
        <CardLine>
            <RedeemValue />
            <StakedTransactions />
        </CardLine>

        <CardLine col="one">
            <ProtocolIncome />
            <DailyIncome />
        </CardLine>
    </>
}